import numberSection from "./numbers/numberSection"

export default function brandsSlider() {
    const sections = document.querySelectorAll('[data-numbers-section]')
    sections.forEach(section => new numberSection(section));
}